import { render, staticRenderFns } from "./AddRegistrationPage.vue?vue&type=template&id=8acd5f86&"
import script from "./AddRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./AddRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports